import createCachedSelector from 're-reselect';
import * as actions from './actionCreators';

const emptyArray = [];
const defaultQuestions = {
  isLoaded: false
};
const defaultQuestionActions = {
  isLoaded: false
};

export const getPartnerQuestionsData = (state, documentId, siteId, partnerId) => {
  let key = actions.loadOfferPartnerQuestionsKey(documentId, siteId, partnerId);
  return state.currentOffer.clientQuestionnaireData.offerPartnerQuestions[key] || defaultQuestions;
};

export const getPartnerQuestionActionsData = (state, documentId, siteId, partnerId) => {
  let key = actions.loadOfferPartnerQuestionActionsKey(documentId, siteId, partnerId);
  return state.currentOffer.clientQuestionnaireData.offerPartnerQuestionActions[key] || defaultQuestionActions;
};

export const getPartnerQuestionsIsLoaded = createCachedSelector(getPartnerQuestionsData, partnerQuestions => {
  return partnerQuestions.isLoaded;
})((_, documentId, siteId, partnerId) => actions.loadOfferPartnerQuestionsKey(documentId, siteId, partnerId));

export const getPartnerQuestionActionsIsLoaded = createCachedSelector(getPartnerQuestionActionsData, partnerQuestionActions => {
  return partnerQuestionActions.isLoaded;
})((_, documentId, siteId, partnerId) => actions.loadOfferPartnerQuestionActionsKey(documentId, siteId, partnerId));

const getPartnerQuestions = (state, documentId, siteId, partnerId) => {
  let key = actions.loadOfferPartnerQuestionsKey(documentId, siteId, partnerId);
  const offerPartnerQuestions = state.entities.offerPartnerQuestions[key];
  return offerPartnerQuestions ? offerPartnerQuestions.questions : emptyArray;
};

export const getTotalScore = (state, documentId, siteId, partnerId) => {
  let key = actions.loadOfferPartnerQuestionsKey(documentId, siteId, partnerId);
  const offerPartnerQuestions = state.entities.offerPartnerQuestions[key];
  return !offerPartnerQuestions ? null : offerPartnerQuestions.totalScore !== 0 ? offerPartnerQuestions.totalScore : null;
};

const getPartnerQuestionActions = (state, documentId, siteId, partnerId) => {
  let key = actions.loadOfferPartnerQuestionActionsKey(documentId, siteId, partnerId);
  const offerPartnerQuestionActions = state.entities.offerPartnerQuestionActions[key];
  return offerPartnerQuestionActions ? offerPartnerQuestionActions.questionActions : emptyArray;
};

export const getOfferPartnerQuestions = createCachedSelector(
  getPartnerQuestionsIsLoaded,
  getPartnerQuestions,
  (isLoaded, partnerQuestions) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return partnerQuestions;
  }
)((_, documentId, siteId, partnerId) => actions.loadOfferPartnerQuestionsKey(documentId, siteId, partnerId));

export const getOfferPartnerQuestionActions = createCachedSelector(
  getPartnerQuestionActionsIsLoaded,
  getPartnerQuestionActions,
  (isLoaded, partnerQuestionActions) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return partnerQuestionActions;
  }
)((_, documentId, siteId, partnerId) => actions.loadOfferPartnerQuestionActionsKey(documentId, siteId, partnerId));
